import { Component, OnInit } from '@angular/core';
import { LibrariesService } from '../../services/libraries-service';
import { BaseComponent } from '../../../../shared/Components/base/base.component';
import { Router } from '@angular/router';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { AddLibraryComponent } from '../add-library/add-library.component';
import { GetLibraryDetailsComponent } from '../get-library-details/get-library-details.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PagingService } from '../../../../shared/Services/PagingService';

@Component({
  selector: 'app-get-libraries',
  templateUrl: './get-libraries.component.html',
  styleUrls: ['./get-libraries.component.scss']
})
export class GetLibrariesComponent extends BaseComponent implements OnInit {


  form:FormGroup

  constructor(
    public service: LibrariesService,
    route: Router,
    private fb: FormBuilder,
    private diag: NbDialogService,
    private toast: NbToastrService,
    private paging: PagingService
  ) {
    super(route, service, paging);
  }

  ngOnInit() {
    this.initForm();
    this.loadEntities();
  }
initForm(){
  this.form = this.fb.group({
    nameAR: [''],
    code: ['']
  });
}


clearFilter(){

  if((this.form.controls['nameAR'].value == '' ) && (this.form.controls['code'].value == '' ) ) 
  {
    return 
  }

  this.form.controls['nameAR'].setValue('');
  this.form.controls['code'].setValue('');
  this.loadEntitiesWithFilter('')
}

handleSearch(){
let searchArr = [];
  
  if(this.form.value.nameAR.trim()){
    let name = this.form.value.nameAR.trim(); 
    this.form.controls['nameAR'].setValue(name);
    searchArr.push(`nameAR:${name}`)
  }
  if(this.form.value.code.trim()){
    let code = this.form.value.code.trim(); 
    this.form.controls['code'].setValue(code);
    searchArr.push(`code:${code}`)
  }
  if(searchArr.length == 0){

    this.toast.danger('برجاءاختيار الاسم او الكود لاتمام عمليةالبحث', 'رساله تحذيرية');
        return
  }
  this.loadEntitiesWithFilter(searchArr.join(','))
}

  addNew() {
    this.diag
      .open(AddLibraryComponent, {
        dialogClass: 'custom-dialog-height',
      })
      .onClose.subscribe((res) => {
        if (res === 'true') this.loadEntities();
      });
  }

  delete(id) {
    this.service.delete(id).subscribe((res) => {
      this.toast.show('تم الحذف  بنجاح', '', { status: 'success', duration: 3000 });

      this.loadEntities();
    });
  }

  detail(model) {
    this.diag
    .open(GetLibraryDetailsComponent, {
      dialogClass: 'custom-dialog-height',
      context: {
        model: model,
      },
    })
    .onClose.subscribe((res) => {
      if (res === 'true') this.loadEntities();
    });
  }

  update(model) {
    const copymodel = {...model}
    this.diag
      .open(AddLibraryComponent, {
        dialogClass: 'custom-dialog-height',
        context: {
          model: copymodel,
          isEdit: true,
        },
      })
      .onClose.subscribe((res) => {
        if (res === 'true') this.loadEntities();
      });
  }
}
